
import React from 'react'
import TermsFeature from '../../features/Terms'
import CustomHeader from '../../components/CustomHeader'
import PAGE_TITLES from '../../consts/titles'
import { Box } from '@mui/material'
import TermsTab from '../../features/Terms/TermsTab'
import PageHeader from '../../components/PageHeader'

const TermsPage: React.FC = (): JSX.Element => {
  return (
    <>
      <Box display='flex' flexDirection='column'>
        <CustomHeader title={PAGE_TITLES.TERMS} />
        <PageHeader title={PAGE_TITLES.TERMS} />
        <TermsTab />
        <TermsFeature />
      </Box>
    </>
  )
}

export default TermsPage
